module.exports = __webpack_public_path__ + "img/stock-01.99e39c3.jpg";